import { useAdRouteParams } from './useAdRouteParams';
import { useAnalyticalDatasetProfileQuery } from '../api/useAnalyticalDatasetProfileQuery';
import type { UseAnalyticalDatasetDetailMetaRowResult } from '../types';

export const useAnalyticalDatasetDetailMetaRow = (): UseAnalyticalDatasetDetailMetaRowResult => {
  const { projectId, analyticalDatasetProfileId } = useAdRouteParams();
  const { data } = useAnalyticalDatasetProfileQuery({ projectId, analyticalDatasetProfileId });
  const profile = data?.data;

  const ownerName = profile?.createdBy
    ? `${profile.createdBy.firstName} ${profile.createdBy.lastName}`.trim()
    : null;

  return {
    isReady: !!profile,
    status: profile?.latestStatus ?? null,
    ownerName,
    lastModifiedDate: profile?.modifiedBy?.transactionDate ?? null,
    datasetReleaseId: profile?.latestDatasetReleaseId ?? null,
    datasetReleaseName: profile?.latestDatasetReleaseName ?? null,
  };
};
